import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "banner w-full bg-neutral-900 rounded-md border border-white border-opacity-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.image)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "banner relative w-full bg-neutral-900 rounded-md overflow-hidden border border-white border-opacity-5",
        style: _normalizeStyle((_ctx.image) ? { backgroundImage: 'url(' + _ctx.image + ')' } : '')
      }, null, 4))
    : (_openBlock(), _createElementBlock("div", _hoisted_1))
}